<template>
  <div style="height: 100%">
    <el-menu :default-active="$store.state.activeTabs"
             style="min-height: 100%; overflow-x: hidden;height:100%;overflow-y: auto;"
             :collapse-transition="false"
             :collapse="isCollapse"
             :unique-opened="$store.state.settingItem.accordion"
             router
             @select="handleSelect"
             :backgroundColor="$store.state.asideColor"
             :text-color="$store.state.asideTextColor"
             active-text-color="#fff"
             class="menu"
    >
      <el-menu-item>
        <img src="../assets/cangku.png" alt="" style="width: 25px; position: relative;">
        <span style="font-size: 20px;color: white;vertical-align: middle;margin-left: 10px;font-weight: bold"
              :style="{ color: $store.state.asideTextColor }">仓库管理系统</span>
      </el-menu-item>
      <el-menu-item index="/home">
        <i class="el-icon-s-home"></i>
        <span slot="title">系统主页</span>
      </el-menu-item>
      <el-submenu index= "1" v-if="user.room === '财务科' || user.room === '管理员' || user.room === '仓库'">
        <template slot="title"><i class="el-icon-notebook-2"></i><span slot="title">材料信息管理</span></template>
        <el-menu-item index="/cleibie" class="bg"><i class="el-icon-document"></i><span slot="title">材料配置</span></el-menu-item>
        <el-menu-item index="/cxinxi" class="bg"><i class="el-icon-reading"></i><span slot="title">库存信息</span></el-menu-item>
      </el-submenu>
      <el-submenu index= "2" v-if="user.room === '财务科' || user.room === '管理员' || user.room === '仓库'">
        <template slot="title"><i class="el-icon-sold-out"></i><span slot="title">入库信息管理</span></template>
        <el-menu-item-group v-if=" user.room === '管理员' || user.room === '财务科'">
          <template slot="title">填报</template>
          <el-menu-item index="/newruku" class="bg" v-if="user.room === '财务科' || user.room === '管理员'">入库填报</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group title="入库" v-if="user.room === '管理员' || user.room === '仓库'">
          <el-menu-item index="/setruku" class="bg" v-if="user.room === '仓库' || user.room === '管理员'">材料入库</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group title="汇总" v-if="user.room === '财务科' || user.room === '管理员' || user.room === '仓库'">
          <el-menu-item index="/ruku" class="bg" v-if="user.room === '财务科' || user.room === '仓库' || user.room === '管理员'">入库信息汇总</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index= "3" v-if="user.room === '财务科' || user.room === '仓库' || user.room === '技术科' || user.room === '营业室' || user.room === '管理员'">
        <template slot="title"><i class="el-icon-sell"></i><span slot="title">出信息库管理</span></template>
        <el-menu-item-group v-if="user.room === '技术科' || user.room === '管理员' || user.room === '营业室' || user.room === '仓库' || user.room === '财务科'">
          <template slot="title">填报</template>
          <el-menu-item index="/yltjtb" class="bg" v-if="user.room === '技术科' || user.room === '管理员' || user.room === '营业室' || user.room === '财务科'">用户购买填报</el-menu-item>
          <el-menu-item index="/yltjgc" class="bg" v-if="user.room === '技术科' || user.room === '管理员' || user.room === '仓库'">工程领料填报</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group title="结算" v-if="user.room === '营业室' || user.room === '管理员' || user.room === '财务科'">
          <el-menu-item index="/ylfyjs" class="bg" v-if="user.room === '营业室' || user.room === '管理员' || user.room === '财务科'">用户费用结算</el-menu-item>
          <el-menu-item index="/ylfyjsg" class="bg" v-if="user.room === '营业室' || user.room === '管理员'">工程费用结算</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group title="出库" v-if="user.room === '仓库' || user.room === '管理员'">
          <el-menu-item index="/usersale" class="bg" v-if="user.room === '仓库' || user.room === '管理员'">用户购买出库</el-menu-item>
          <el-menu-item index="/lingliao" class="bg" v-if="user.room === '仓库' || user.room === '管理员'">工程领料出库</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group title="汇总" v-if="user.room === '财务科' || user.room === '仓库' || user.room === '技术科'  || user.room === '管理员'">
          <el-menu-item index="/lingliaoth" class="bg" v-if="user.room === '财务科' || user.room === '仓库' || user.room === '技术科'  || user.room === '管理员'">工程出库单汇总</el-menu-item>
          <el-menu-item index="/lingliaothx" class="bg" v-if="user.room === '财务科' || user.room === '仓库' || user.room === '技术科'  || user.room === '管理员'">工程出库详情汇总</el-menu-item>
          <el-menu-item index="/usersaleth" class="bg" v-if="user.room === '财务科' || user.room === '仓库' || user.room === '技术科'  || user.room === '管理员'">用户出库单汇总</el-menu-item>
          <el-menu-item index="/usersalethx" class="bg" v-if="user.room === '财务科' || user.room === '仓库' || user.room === '技术科'  || user.room === '管理员'">用户出库详情汇总</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index= "4" v-if="user.room === '财务科' || user.room === '仓库' || user.room === '营业室' || user.room === '管理员'">
        <template slot="title"><i class="el-icon-truck"></i><span slot="title">退库信息管理</span></template>
        <el-menu-item-group v-if="user.room === '技术科' || user.room === '管理员' || user.room === '仓库'">
          <template slot="title">填报</template>
          <el-menu-item index="/gongchengt" class="bg">公司退库填报</el-menu-item>
          <el-menu-item index="/usert" class="bg">用户退库填报</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group title="结算" v-if="user.room === '营业室' || user.room === '管理员' || user.room === '财务科'">
          <el-menu-item index="/paytuiku" class="bg">退库费用结算</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group title="汇总" v-if="user.room === '营业室' || user.room === '管理员' || user.room === '仓库'|| user.room === '财务科' ">
          <el-menu-item index="/gongchength" class="bg">公司退库汇总</el-menu-item>
          <el-menu-item index="/userth" class="bg">用户退库汇总</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index= "5"  v-if="user.room === '财务科' || user.room === '仓库' || user.room === '管理员' || user.room === '技术科'">
        <template slot="title"><i class="el-icon-map-location"></i><span slot="title">工程信息管理</span></template>
        <el-menu-item index="/baozhuang" class="bg" v-if="user.room === '财务科' || user.room === '仓库' || user.room === '管理员' || user.room === '技术科'">工程填报</el-menu-item>
        <!--      <el-menu-item index="/shoufei" class="bg"><i class="el-icon-coin"></i>工程收费</el-menu-item>-->
      </el-submenu>
      <el-submenu index= "6" v-if="user.room === '管理员'">
        <template slot="title"><i class="el-icon-setting"></i><span slot="title">基础设置</span></template>
        <el-menu-item index="/userSetting" class="bg" v-if="user.room === '管理员'">人员管理</el-menu-item>
      </el-submenu>
    </el-menu>
  </div>

</template>

<script>
export default {
  name: "Aside",
  data(){
    return{
      isCollapse:false,
      user:localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {},
      cw:true,
      js:true,
    }

  },
  mounted() {
    this.$bus.$on('isCollapse',(data)=>{
      this.isCollapse = data
    })
  },
  methods:{
    handleSelect(){
      console.log('11111111111111',this.$route)
      console.log(this.$router.options.routes)
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
  }
}
</script>

<style scoped>

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
.el-menu-item.is-active {
  background-color: #2d8cf0 !important; /* 使用 !important 提高优先级 */
}
.menu::-webkit-scrollbar {
  display: none;
}
</style>
